export const archivedEntityRowCss = {
  color: 'fg.muted',
  opacity: 0.65,
} as const;
